/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ImageEditContext } from "cms/images/image-selector/context/image-edit-context";
import { regular } from "cms/icons";

const { faXmark } = regular;

const ImageEditHeader = () => {
    const imageEditContext = useContext(ImageEditContext);
    const handleEditClose = imageEditContext?.handleEditClose;
    
    return (
        <Fragment>
            <div className="simplicity-image-selector-window-header">
                <div className="simplicity-image-selector-window-title edit-title">
                    Edit image
                </div>
                <FontAwesomeIcon
                    className='simplicity-image-selector-window-close-btn'
                    onClick={handleEditClose}
                    icon={faXmark}
                    size="2xl"
                    style={{ color: "#7A7A7A" }}
                />
            </div>
        </Fragment>
    );
};

export { ImageEditHeader };
